( function () {
    'use strict';
    ( function ( $ ) {
        $('.portfolio-filter-wrap select').resizeselect();

        $(document).on('change','.portfolio-filter-wrap select',function(e){
            $('#portfolio-filter-form').submit();
        });
        $(document).on('click','.filter-reset.active',function(e){
            e.preventDefault();
            $('.portfolio-filter-wrap select').each(function(){
                $(this).val('');
            });            
            $('#portfolio-filter-form').submit();
        })
        $(document).on('submit','#portfolio-filter-form',function(e){
            e.preventDefault();
            $.ajax({
                url : $('#portfolio-filter-form').attr('action'),
                dataType: 'html',
                data: $('#portfolio-filter-form').serialize(),
                type:'GET',
                beforeSend: function( xhr ){
                    $('.loader').addClass('active');                    
                    $('.portfolio-grid-container').html('');
                },
                success:function(response){
                    var doc = new DOMParser().parseFromString(response, 'text/html');
                    var resultHtml = $(doc).find('.portfolio-grid-container').html();
                    var filterHtml = $(doc).find('.portfolio-filter-bar').html();
                    $('.portfolio-grid-container').html(resultHtml);
                    $('.portfolio-filter-bar').html(filterHtml);
                    $('.loader').removeClass('active');
                    $('.portfolio-filter-wrap select').resizeselect();
                }
            });
        });
    } )( jQuery );
} )();